import React from 'react';

import { Block, withBlockRendering } from '../common/Block.jsx';
import { BuilderBlock } from '../layout/Builder.jsx';
import Columns from './Columns.jsx';
import Name from '../common/Name.jsx';
import { TabSelectionDropDown } from '../common/Tab.jsx';

function _HoverContentComponent(props) {
    const [currentState, setCurrentState] = React.useState('default');

    const blocks = props.blocks || [];
    const blocksDefault = blocks.length > 0 ? blocks[0] : [];
    const blocksHover = blocks.length > 1 ? blocks[1] : [];
    let styleDefault, styleHover;
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            styleDefault = {};
            Block.mapStyleConfigProps(styleDefault, props.blockConfig.block)
        }
        if (props.blockConfig.hover) {
            styleHover = {};
            Block.mapStyleConfigProps(styleHover, props.blockConfig.hover)
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    const styleHoverContainer = { left: layoutStyles.style.paddingLeft, right: layoutStyles.style.paddingRight };
    if (props.builder) {
        styleHoverContainer.transition = 'none';
    }
    let className = 'cont--kit__content hover__cont';
    if (currentState == 'hover') {
        className += ' hover__cont--active';
    }
    if (props.inPopup) {
        className += ' popup__content';
    }
    let content = (
        <div className={className} data-block-type={Name.Block.HoverContent} style={layoutStyles.style}>
            <Columns.ChildComponent
                {...props}
                blocks={blocksDefault}
                blockType={Name.Block.HoverContent}
                index={0}
                inCell={props.inCell}
                inLayout={true}
                minHeight="27px"
                minWidth="40px"
                style={styleDefault} />
                <div>
            <div className="hover__cont--hover" style={styleHoverContainer}>
                <Columns.ChildComponent
                    {...props}
                    blocks={blocksHover}
                    blockType={Name.Block.HoverContent}
                    index={1}
                    inCell={props.inCell}
                    inLayout={true}
                    minHeight="27px"
                    minWidth="40px"
                    style={styleHover} />
            </div>
            </div>
        </div>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    if (props.builder) {
        content = (
            <React.Fragment>
                <BuilderBlock blockType={Name.Block.HoverContent} {...props}>
                    <TabSelectionDropDown
                        label="STATE"
                        tab={currentState}
                        onBlockMove={props.onBlockMove}
                        onSelect={setCurrentState}>
                        <option value={'default'}>Default</option>
                        <option value={'hover'}>Hover</option>
                    </TabSelectionDropDown>
                    {content}
                    <div className="drag-outline drag-outline-layout drag-outline-layout-parent" />
                </BuilderBlock>
                {
                    props.dragging &&
                    <div id={`${props.blockId}-hidden`} className="hidden draggable" onDragEnter={props.onDragEnter} />
                }
            </React.Fragment>
        );
    }
    return content;
}
const HoverContentComponent = withBlockRendering(_HoverContentComponent);

export default { Component: HoverContentComponent }